import {IPublisherLogins} from "../interfaces/IPublisherLogins";

export const initialPublisherLoginObj: IPublisherLogins = {
    advertiserId: '',
    publisherId: '',
    advertiserName: '',
    publisherName: '',
    supplyPartners: []
}